export const alphaDuneTestnetContracts = {
  PAYMENTS: '0xB13baCba9cc4F30F7e50AeC555115C90a558daEb',
  HOUNDRACE_POTIONS: '0x5Cd60428778cB465848b44eC3495BeF72265e358',
  SHOP: '0xCff03f2E57AA9CAAcaBFD953A61f1745bafD36B0',
  ARENAS: '0x0df36951c30F3A3DA62966a821F6B65C165fbED5',
  GENETICS: '0xECEE40dB1734770Bf785c7a28089e6C405707035',
  HOUNDS: '0x6aa7Bb1e71ad3D8062203F2aa3edEA68F7F2Eb4c',
  RACES: '0x79b6f6e38DcA0Cc2bB49471B41462866a7142Bd8',
  QUEUES: '0x7AF123bB344d7584f43d287556b054D781D93F52',
  LOOTBOXES: '0x985D3657F497Be95c1236d1B9c1F9954CA48afb2'
};

export function contracts(chain_id: number): ContractsInventory {
  console.log("Getting contracts for: ", chain_id);
  switch(Math.abs(chain_id)) {
    case 4126084:
      return alphaDuneTestnetContracts;
    default:
      return alphaDuneTestnetContracts;
  }
}

export interface ContractsInventory {
  PAYMENTS: string;
  HOUNDRACE_POTIONS: string;
  SHOP: string;
  ARENAS: string;
  GENETICS: string;
  HOUNDS: string;
  RACES: string;
  QUEUES: string;
  LOOTBOXES: string;
}
